import Link from "next/link";
import { useState } from "react";

import { MainButton } from "../ui-components/MainButton";
import { buttonVariants } from "../ui-components/MainButton/buttonVariants";
import styles from "./CookieWarning.module.scss";

const CookieWarning = () => {
  const [isCookieWarningSet, setCookieWarningSet] = useState<boolean>(
    !!window.localStorage.getItem("isCookieWarningViewed")
  );

  const setCookieWarningViewed = () => {
    window.localStorage.setItem("isCookieWarningViewed", "1");
    setCookieWarningSet(true);
  };

  if (isCookieWarningSet) return null;

  return (
    <div className={styles.root}>
      <div className={styles.textContainer}>
        <p className={styles.text}>
          Наш сайт использует файлы cookie, чтобы повысить эффективность.
          Продолжая использовать сайт, вы соглашаетесь с условиями{" "}
          <Link
            href="/articles/documents"
            onClick={setCookieWarningViewed}
          >
            Политики конфиденциальности
          </Link>
          .
        </p>
        <MainButton
          className={styles.agreeButton}
          variant={buttonVariants.BRIGHTWHITE}
          onClick={setCookieWarningViewed}
        >
          Принимаю
        </MainButton>
      </div>
    </div>
  );
};

export default CookieWarning;
